import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import downarrow from "../Image/downArrow.png";
import Signup from "./Signup";

function Feedback() {
  const { register, handleSubmit, watch } = useForm();
  const message = watch("message", "");
  const [showSignup, setShowSignup] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <>
      <div className="feedback-section">
        <div className="container">
          <div className="row text-wrapper">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-6 col-xl-8">
              <h2 className="title">Crash Gambling Game</h2>
              <p className="desc">
                Crash is an online crypto game for real gamblers. Mr. Fury has
                loaded his rocket and goes into space, and you actually have to
                help him fly as much as possible. You place a bet, the engines
                start, and the multiplier increases. If you collect the winnings
                before the raccoon falls, you will receive the collected amount.
                Let's take a closer look at the rules and capabilities of Crash
                betting.
              </p>
              {showMore && (
                <p className="desc">
                  In Crash, timing is everything. Players must decide when to
                  cash out before the rocket crashes. The longer the rocket
                  flies, the higher the multiplier becomes. However, if the
                  rocket crashes before you cash out, you lose your bet. The
                  game combines luck, strategy, and quick decision-making for an
                  exciting experience.
                </p>
              )}

              <button
                type="button"
                className="show-btn"
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ? "Show Less" : "Show More"}

                <img
                  src={downarrow}
                  alt=""
                  style={{
                    marginLeft: "8px",
                    transform: showMore ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "0.3s",
                  }}
                />
              </button>
            </div>

            <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-6 col-xl-8">
              <h2 className="title">Let’s improve your gaming experience</h2>
              <p className="desc">
                Have you found a bug or have an idea for the platform 
                improvement? Please, leave your message here!
              </p>

              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Select
                  {...register("subject")}
                  className="custom-input mb-3"
                >
                  <option value="">Select a feedback subject</option>
                  <option value="bug">Bug</option>
                  <option value="idea">Idea</option>
                </Form.Select>

                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Your feedback"
                  {...register("message")}
                  className="custom-input mb-2"
                />

                <div className="counter">{message.length}/1500 characters</div>
              </Form>

              <div className="d-flex align-items-center gap-3 flex-wrap mt-4 button-wrapper">
                <button
                  type="submit"
                  className="submit-btn"
                  onClick={() => setShowSignup(true)}
                >
                  Sign up or Login
                </button>

                <p className="email-text mb-0">
                  Or Email us: <span>feedback@betking.io</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showSignup && (
        <Signup onClose={() => setShowSignup(false)} setIsAuth={() => {}} />
      )}
    </>
  );
}

export default Feedback;
